import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() { return ["birthday"]; }

  connect() {
    $(this.birthdayTarget).datetimepicker({
      ...window.datetimepickerDefaults,
      // End of day, not the current instant: selectDay builds the clicked date from the picker's
      // init time-of-day and setValue compares it to maxDate at millisecond precision, so
      // `new Date()` makes today itself intermittently unselectable.
      maxDate: moment().endOf("day"),
    });
  }
}
